const featureStore: Record<string, boolean> = {};

export const hydrateFeatures = () => {
  const paramsString = window?.location.href.split('?')[1];
  const searchParams = new URLSearchParams(paramsString);
  const features = searchParams.get('features');

  if (features) {
    features.split(',').forEach((feature) => {
      featureStore[feature] = true;
    });
  }
};

type FeatureName = 'show-hidden-preferences';

export const isFeatureActive = (featureName: FeatureName): boolean =>
  Boolean(featureStore[featureName]);
